import C from '@/config/index'
import Utils from '@/utils/util'
import { useUserStore, useOtherStore } from '@/store'
import md5 from 'md5'
import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
import axios from 'axios'
import Cache from './cache'
import { computed } from 'vue'
import router from '@/router/index'
/**
 * 常用方法封装 请求，文件上传等
 * @author gs089597@163.com
 **/
let loadingObj = ''
const Jiu = {
    app: {},
    toast: function(text, duration, type) {
        ElMessage({
            showClose: true,
            type: type ?? 'success',
            message: text || '出错啦~',
            duration: duration || 2000
        })
    },
    modal: function(title, content, showCancel, callback, type, cancelText, confirmText) {
        ElMessageBox.confirm(
            content,
            title || '提示',
            {
                confirmButtonText: confirmText || '确定',
                showCancelButton: showCancel || false,
                cancelButtonText: cancelText || '取消',
                type: type || 'info'
            }
        ).then(() => {
            callback && callback(true)
        }).catch(() => {
            callback && callback(false)
        })
    },
    constNum: function() {
        let time = 0
        // #ifdef APP-PLUS
        time = this.isAndroid() ? 300 : 0
        // #endif
        return time
    },
    delayed: null,
    codesum401: 1,
    showLoading: function(title, mask = true) {
        loadingObj = ElLoading.service({
            lock: true,
            text: title || '请稍候...',
            background: 'rgba(0, 0, 0, 0.7)'
        })
    },
    /**
     * 请求数据处理
     * @param string url 请求地址
     * @param string method 请求方式
     *  GET or POST
     * @param {*} postData 请求参数
     * @param bool isDelay 是否延迟显示loading
     * @param bool isForm 数据格式
     *  true: 'application/x-www-form-urlencoded'
     *  false:'application/json'
     * @param bool hideLoading 是否隐藏loading
     *  true: 隐藏
     *  false:显示
     */
    request: async function(url, postData, method = 'GET', hideLoading = true, isDelay = false, isForm = false, dataType = 'json') {
        // 接口请求
        let loadding = false
        Jiu.delayed && loadingObj.close()
        clearTimeout(Jiu.delayed)
        Jiu.delayed = null
        if (!hideLoading) {
            if (isDelay) {
                Jiu.delayed = setTimeout(() => {
                    loadding = true
                    Jiu.showLoading()
                }, 1000)
            } else {
                loadding = true
                Jiu.showLoading()
            }
        }
        return new Promise((resolve, reject) => {
            // return
            let params = {
                jiu_app_key: C.AppKey,
                jiu_timestamp: Date.parse(new Date()) / 1000,
                jiu_nonce: Utils.randomString(32),
                jiu_access_token: Jiu.accessToken.value
            }
            postData = Object.assign(params, postData)
            console.log(url)
            axios.request({
                url: url,
                params: method === 'GET' ? Jiu.getPostData(postData, C.AppSecret) : '',
                data: method !== 'GET' ? Jiu.getPostData(postData, C.AppSecret) : '',
                headers: {
                    'Content-Type': isForm ? 'application/x-www-form-urlencoded' : 'application/json',
                    'Device-Type': C.DeviceType,
                    'Response-Type': dataType,
                    'Lang-Type': Cache.get('lang')
                },
                method: method, // 'GET','POST'
                responseType: dataType
            }).then((res) => {
                clearTimeout(Jiu.delayed)
                Jiu.delayed = null
                if (res.data.message === 'options') {
                    return false
                }
                if (loadding && !hideLoading) {
                    loadingObj.close()
                }
                if (res.data.code === 200) {
                    resolve(res.data)
                } else {
                    reject(res.data)
                }
                if (res.data.refresh) {
                    if (res.data.refresh.token) {
                        Jiu.otherStore.refreshToken += 1
                    }
                    if (res.data.refresh.config) {
                        Jiu.otherStore.refreshConfig += 1
                    }
                    if (res.data.refresh.menus) {
                        Jiu.otherStore.refreshMenus += 1
                    }
                }
                Jiu.codesum401 = 1
            }).catch((res) => {
                clearTimeout(Jiu.delayed)
                Jiu.delayed = null
                if (res.response.data.code === 401) {
                    if (Jiu.codesum401 === 1) {
                        Jiu.userStore.logout()
                        router.push('/admin/public/login')
                    }
                    Jiu.codesum401 += 1
                    return false
                }
                if (res.response) {
                    reject(res.response.data)
                }
                reject(res)
            })
        })
    },
    UpdateParams(parames) {
        let params = {
            jiu_app_key: C.AppKey,
            jiu_timestamp: Date.parse(new Date()) / 1000,
            jiu_nonce: Utils.randomString(32),
            jiu_access_token: Jiu.accessToken.value,
            'dir': parames.dir,
            'module': parames.module,
            'cid': parames.cid,
            'is_auth': parames.is_auth
        }
        let uploadData = Jiu.getPostData(params, C.AppSecret)
        let uploadHeader = {
            // 'content-type': 'application/json', // 默认值
            'Device-Type': C.DeviceType
        }
        return { parames: uploadData, header: uploadHeader }
    },
    getPostData(data, AppSecret) {
        let sortData = Utils.sortDict(data)
        let urlsrt = Utils.urlEncode(sortData)
        let urlstra = urlsrt.slice(1)
        let dm = urlstra + '&jiu_key=' + AppSecret
        let md5str = md5(dm).toLowerCase()
        sortData.jiu_signature = md5str
        return sortData
    },
    showError(error) {
        Jiu.toast(error.message, '', 'error')
    },
    jsonp(url) {
        if (!url) {
            return
        }
        return new Promise((resolve, reject) => {
            window.jsonCallBack = (result) => {
                resolve(result)
            }
            var JSONP = document.createElement('script')
            JSONP.type = 'text/javascript'
            JSONP.src = `${url}&callback=jsonCallBack`
            document.getElementsByTagName('head')[0].appendChild(JSONP)
            setTimeout(() => {
                document.getElementsByTagName('head')[0].removeChild(JSONP)
            }, 500)
        })
    },
    getFormData(obj) {
        const data = {}
        obj.value.forEach((item, index) => {
            if (item.type === 'group') {
                for (const i in item.options) {
                    for (const ii in item.options[i]) {
                        data[item.options[i][ii].name] = item.options[i][ii].value
                    }
                }
            } else {
                if (item.type === 'daterange' || item.type === 'datetimerange' || item.type === 'timerange') {
                    data[item.id_from] = item.value[0]
                    data[item.id_to] = item.value[1]
                    if (item.name === item.name_from) {
                        data[item.name] = item.value
                    }
                } else {
                    data[item.name] = item.value
                }
            }
        })
        return data
    }
}

export default {
    install: (app, options) => {
        Jiu.app = app
        Jiu.userStore = useUserStore()
        Jiu.otherStore = useOtherStore()
        Jiu.accessToken = computed(() => Jiu.userStore.accessToken)
        app.config.globalProperties.jiu = Jiu
    },
    jiu: Jiu
}
